import { render, staticRenderFns } from "./ModuloDeInternacao.vue?vue&type=template&id=6f5ceb36&"
import script from "./ModuloDeInternacao.vue?vue&type=script&lang=js&"
export * from "./ModuloDeInternacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports